export default __webpack_public_path__ + "static/media/Ellipse 12.f4d21e33.svg";